import { API } from 'helpers/api/endpoints';
import useData from 'hooks/useData';
import { Alert, Col, Row, Spinner } from 'react-bootstrap';
import { getCustomerWithDetailsResponse } from 'types';
import AddressTable from './AddressTable';
import CompanyNameForm from './CompanyNameForm';
import CustomerUsersDetaisTable from './CustomerUsersDetaisTable';
import { useTranslation } from 'react-i18next';
type Props = {
  customerGuid: string | undefined;
};
const EditCustomer = ({ customerGuid }: Props) => {
  const {t}= useTranslation()
  const { data: customer, refetch,loading,error } = useData<getCustomerWithDetailsResponse>(
    API.customers.withDetails(customerGuid!)
  );
  if(loading) return <Spinner animation="border" variant="secondary" />
  if (error) return <Alert variant="danger">{t('loading_error', { ns: 'benutzerliste' })}</Alert>;
  if (!customer || customer.deleted)
    return <Alert variant="warning">{t('disabled_account', { ns: 'benutzerliste' })}</Alert>;
  return (
    <>
      <Row>
        <Col lg={5} className="mb-3">
          <CompanyNameForm customer={customer} />
        </Col>
        <Col lg={7} className="mb-3">
          {customer.users && (
            <CustomerUsersDetaisTable
              users={customer.users}
              refetch={refetch}
            />
          )}
        </Col>
      </Row>

      {customerGuid && (
        <AddressTable
          addresses={customer.addresses}
          customerGuid={customerGuid}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default EditCustomer;
